
const _nowBrowser = ( ()=>{
    let agt = navigator.userAgent.toLowerCase();
    let trident = agt.match(/trident\/(\d.\d)/i);

    if( trident !== null ){
        if( trident[1] == "7.0" ) return "IE" + 11;
        if( trident[1] == "6.0" ) return "IE" + 10;
        if( trident[1] == "5.0" ) return "IE" + 9;
        if( trident[1] == "4.0" ) return "IE" + 8;
    }

    if( navigator.appName == 'Microsoft Internet Explorer' ) return "IE" + 7;

    if (agt.indexOf("edge") != -1) return 'Edge';
    if (agt.indexOf("chrome") != -1) return 'Chrome';
    if (agt.indexOf("opera") != -1) return 'Opera';
    if (agt.indexOf("staroffice") != -1) return 'Star Office';
    if (agt.indexOf("webtv") != -1) return 'WebTV';
    if (agt.indexOf("beonex") != -1) return 'Beonex';
    if (agt.indexOf("chimera") != -1) return 'Chimera';
    if (agt.indexOf("netpositive") != -1) return 'NetPositive';
    if (agt.indexOf("phoenix") != -1) return 'Phoenix';
    if (agt.indexOf("firefox") != -1) return 'Firefox';
    if (agt.indexOf("safari") != -1) return 'Safari';
    if (agt.indexOf("skipstone") != -1) return 'SkipStone';
    if (agt.indexOf("netscape") != -1) return 'Netscape';
    if (agt.indexOf("mozilla/5.0") != -1) return 'Mozilla';
})();

const _isMobile = (/(android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|NC Noob)/i.test(navigator.userAgent.toLowerCase()));

const _isVideoSupport = _nowBrowser!='IE7' && _nowBrowser!='IE8' && !_isMobile;

const _movExt = ( _nowBrowser=='Chrome' )? '.webm': '.mp4';

Math.easeOutQuad = function (t, b, c, d) {
    t /= d;
    return -c * t*(t-2) + b;
};

Math.easeOutCubic = function (t, b, c, d) {
    t /= d;
    t--;
    return c*(t*t*t + 1) + b;
};

class Utils{
    static get isMobile(){
        return _isMobile;
    }

    static get isVideoSupport(){
        return _isVideoSupport;
    }

    static get movExt(){
        return _movExt;
    }

    static get nowBrowser(){
        return _nowBrowser;
    }

    static setTrace ( depth ){
        try{ _trk_clickTrace( 'EVT', depth ); } catch(_e){}
    }

    static trim (_str) {
        return _str.replace(/^\s+/, "").replace(/\s+$/, "");
    }

    static randomNum (_max, _min) {
        let result = parseInt(Math.random() * (_max-_min+1));
        if(result===(_max-_min+1)) --result;
        result += _min;
        return result;
    }

    static cutStrByIndex (_str, _cutStringIndex, _cutAddStr = '...') {
        let tempStr = _str;
        if (_str.length > _cutStringIndex) tempStr = _str.substr(0, _cutStringIndex) + _cutAddStr;
        return tempStr;
    }

    static reEscape(_str='') {
        return _str
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>' )
            .replace(/&quot;/g, '\"' )
            .replace(/&#39;/g, '\'' );
    }

    static objHasKeys( obj={}, keys=[]) {
        let next = keys.shift();
        return obj[next] && (! keys.length || this.objHasKeys(obj[next], keys));
    }

    static namespace (_namespace='window.console', _parent = window) {
        if ( typeof _namespace === 'string' && _namespace ) {
            let parts = _namespace.split('.');
            for (let i = 0, max = parts.length; i < max; i++) {
                if (!_parent[parts[i]]) _parent[parts[i]] = {};
                _parent = _parent[parts[i]];
            }
        }
        return _parent;
    }



    static getParentPosition(target){
        var left = 0;
        target = target[0];
    
        target = target.offsetParent;
        while (target.offsetParent){
            left += target.offsetLeft;
            target = target.offsetParent;
        }
    
        left += target.offsetLeft;
        return left;
    }


    static cleanSec(_sec){
        _sec = parseInt(_sec);
        if(isNaN(_sec)) _sec = 0;
        return _sec;
    }

    static makeTime(_sec){
        let sec = _sec;
        
        if (sec < 60) {
            return '00:' + this.pad(sec, 2);
        } else if (sec < 3600){
            return this.pad(Math.floor(sec%3600/60), 2) + ':' + this.pad(sec%60, 2);
        } else {
            return this.pad(Math.floor(sec/3600), 2) + ':' + this.pad(Math.floor(sec%3600/60), 2) + ':' + this.pad(sec%60, 2);
        }
    }

    static pad(n, width) {
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n;
    }


    static getParamByName( name, url ) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    static getTranslate(item) {
        var transArr = [];

        if (!window.getComputedStyle) return;
        var style     = getComputedStyle(item),
            transform = style.transform || style.webkitTransform || style.mozTransform || style.msTransform;
        var mat       = transform.match(/^matrix3d\((.+)\)$/);
        if (mat) return parseFloat(mat[1].split(', ')[13]);

        mat = transform.match(/^matrix\((.+)\)$/);
        mat ? transArr.push(parseFloat(mat[1].split(', ')[4])) : transArr.push(0);
        mat ? transArr.push(parseFloat(mat[1].split(', ')[5])) : transArr.push(0);

        return transArr;
    }

    static scrollTo(element, to, duration) {
        let start = element.scrollTop,
            change = to - start,
            currentTime = 0,
            increment = 20;
            
        let animateScroll = ()=>{        
            currentTime += increment;
            let val = Math.easeOutCubic(currentTime, start, change, duration);
            element.scrollTop = val;
            if(currentTime < duration) {
                setTimeout(animateScroll, increment);
            }else{
                // console.log('end???')
            }
        };
        animateScroll();
    }

    static autoLink ( text ) {
        let pattern = /(^|\s?)((https?:\/\/|www)+[-\S.]+)(\s?)/ig;

        return text.replace( pattern, ( a, b, c, d, e ) => {
            return b + '<a href="' + c + '"' + ( /.plaync.(co.kr|com)/ig.test( c ) ? '' : ' target="_blank"' ) + '>' + c + '</a>' + e;
        });
    }
    
    static addThousandSeparatorCommas(num) {
        return (''+num).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    static setCookie( name, value, expiredays ) {
        let todayDate = new Date();
        todayDate.setDate( todayDate.getDate() + expiredays );
        document.cookie = name + "=" + escape( value ) + "; path=/; domain=.plaync.com;expires=" + todayDate.toGMTString() + ";";
    }

    static getCookie(name) {
        let cookies = document.cookie;
        if(cookies.indexOf(name)==-1)return false;
        let cookie = cookies.substr(cookies.indexOf(name));
        cookie = cookie.split(';')[0];
        cookie = cookie.substr(cookie.indexOf('=')+1);
        return cookie;
    }

    getParamByName( name, url ) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    static replaceTag ( text, noBr ) {
        if ( !text ) return '';
        let txt = text.replace( /</g, '&lt;' ).replace( />/g, '&gt;' );
        if( !noBr ) txt = txt.replace( /\n/g, ' <br />' );
        return txt;
    }


    /**
     * URL에 파라미터 추가하기
     * @param  {String} _key
     * @param  {String} _val
     * @param  {String} _url
     * @returns {String}
     * @example
     * Utils.addParam( 'page_no', '43' ),
     */
    static addParam(_key = 'key', _val = 0, _url = window.location.href){
        if(_url.indexOf('?') > -1){ //?파람이 있는 경우 
            
            if(_url.indexOf(_key) > -1){ // 해당 키값이 이미 존개하는경우 
                let regex = new RegExp(_key + "(=([^&#]*)|&|#|$)");
                _url = _url.replace( regex, `${_key}=${_val}`);
            }else{ //해당 키값이 없는경우
                _url += `&${_key}=${_val}`;
            }
        }else{ //?파람이 없는 경우 
            _url += `?${_key}=${_val}`;
        }
        return _url;
    }

    /**
     * URL에 파라미터 삭제하기
     * @param  {String} _key
     * @param  {String} _url
     * @returns {String}
     * @example
     * Utils.removeParam( 'page_no'),
     */
    static removeParam(_key = 'key', _val='', _url = window.location.href){
        const param = Utils.getParamByName(_key);

        if(param){ //?파람이 있는 경우 
            const values = param.split(',');

            if(values.length > 1){ // 값이 2개 이상일 경우 해당 값만 삭제
                _url =  _url.replace(param, values.filter( val => val !== _val).join(''))
            }else{ // 값이 하나일 경우 key도 삭제 
                _url = _url.split(`&${_key}=${_val}`).join('');
            }
        }
        return _url;
    }
}





export default Utils;